import moment from 'moment';

// Dates are passed with timezone info, which can cause the date
// to shift when interpreted between timezones. We strip the time
// component and return a plain YYYY-MM-DD string to avoid this mismatch.
const stripTimeFromDate = date => {
  if (date && moment(date).isValid()) {
    return moment(date).format('YYYY-MM-DD');
  }
  return date;
};

export default stripTimeFromDate;
